var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoResultadosBeneficios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico_resultados_y_beneficios",
    "data-name": "ico_resultados y beneficios",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_86",
    "data-name": "Rect\\xE1ngulo 86",
    width: 100,
    height: 100,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_167",
    "data-name": "Grupo 167",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_304",
    "data-name": "Trazado 304",
    d: "M100,50A50,50,0,1,1,50,0a50,50,0,0,1,50,50",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_305",
    "data-name": "Trazado 305",
    d: "M88.9,55.049c16.447,1.322,26.271,19.594,17.7,33.848-5.949,10.64-20.477,14.374-30.826,7.93-.831-.488-.826-.5-1.5.174-3.219,3.28-9.152,9.085-12.374,12.365a3.913,3.913,0,1,1-5.681-5.382c.042-.044.084-.087.128-.129L69.236,90.966A22.538,22.538,0,0,1,85.593,55.049Zm15.724,22.482A17.338,17.338,0,0,0,87.338,60.14h-.086c-23.022.8-23.083,33.916-.017,34.764A17.341,17.341,0,0,0,104.623,77.61v-.079",
    transform: "translate(-32.854 -32.792)",
    fill: "#4a4395"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_83",
    "data-name": "Rect\\xE1ngulo 83",
    width: 4.637,
    height: 21.629,
    transform: "translate(52.077 33.817)",
    fill: "#4a4395"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_84",
    "data-name": "Rect\\xE1ngulo 84",
    width: 4.66,
    height: 17.71,
    transform: "translate(58.306 37.749)",
    fill: "#4a4395"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_85",
    "data-name": "Rect\\xE1ngulo 85",
    width: 4.66,
    height: 13.762,
    transform: "translate(45.818 41.687)",
    fill: "#4a4395"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoResultadosBeneficios);
export default __webpack_public_path__ + "static/media/ico_resultados_beneficios.b4104723f65ba2339530ee6305cee9b9.svg";
export { ForwardRef as ReactComponent };